import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Hammer, Compass } from 'lucide-react';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="err-404-wrapper">
      
      {/* 1. THE BACKGROUND DECORATION (Rotating Wood Rings) */}
      <motion.div 
        animate={{ rotate: 360 }}
        transition={{ duration: 50, repeat: Infinity, ease: "linear" }}
        className="err-404-deco"
      >
        <svg viewBox="0 0 100 100">
          <path d="M50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm0 90C27.9 90 10 72.1 10 50S27.9 10 50 10s40 17.9 40 40-17.9 40-40 40z" fill="none" stroke="currentColor" strokeWidth="0.2" opacity="0.2"/>
          <circle cx="50" cy="50" r="30" stroke="currentColor" strokeWidth="0.1" fill="none" opacity="0.3" />
          <circle cx="50" cy="50" r="20" stroke="currentColor" strokeWidth="0.1" fill="none" opacity="0.4" />
        </svg>
      </motion.div>

      <div className="err-404-container">
        
        {/* 2. LARGE ANIMATED NUMBERS */}
        <div className="err-404-number-box">
          <motion.span 
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >4</motion.span>
          
          <motion.div 
            className="err-404-zero"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 100, delay: 0.4 }}
          >
            <Compass size={120} strokeWidth={1} />
          </motion.div>

          <motion.span
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >4</motion.span>
        </div>

        {/* 3. TEXT CONTENT */}
        <motion.div 
          className="err-404-content"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <span className="err-404-tag">The Grain Ends Here</span>
          <h1>Lost in the Workshop?</h1>
          <p>
            It seems the piece of the web you are looking for has been repurposed 
            or doesn't exist. Let's get you back to the showroom.
          </p>

          <div className="err-404-btns">
            <button className="err-404-btn-main" onClick={() => navigate('/')}>
              <Home size={18} /> Return to Home
            </button>
            <button className="err-404-btn-outline" onClick={() => navigate(-1)}>
              <ArrowLeft size={18} /> Go Back
            </button>
          </div>
        </motion.div>

        {/* 4. FOOTER SIGNATURE */}
        <motion.div 
          className="err-404-footer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
        >
          <Hammer size={16} /> <span>Handcrafted by Sohani</span>
        </motion.div>
      </div>

    </div>
  );
};

export default NotFound;